// Stacks items vertically. Use within another container that defines dimensions as this has none.

import styled from 'styled-components/macro';

const DPFlex = styled.div`
  display: flex;
  flex-direction: column;
`;

export default DPFlex;